const facilities = [
  {
    name: "Aberdeen Main Post Office",
    address: "317 S 1st St, Aberdeen, SD 57401",
    hours: "Mon–Fri 8:30am–5:00pm",
    note: "Primary downtown acceptance facility",
    phone: "(605) 225-1680",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Aberdeen North Post Office",
    address: "2600 6th Ave NE, Aberdeen, SD 57401",
    hours: "Mon–Fri 8:30am–4:30pm",
    note: "North side of Aberdeen near NSU",
    phone: "(605) 225-6230",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Brown County Courthouse",
    address: "25 Market St, Aberdeen, SD 57401",
    hours: "Mon–Fri 8:00am–5:00pm",
    note: "County seat government center",
    phone: "(605) 626-7100",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Groton Post Office",
    address: "117 N 3rd St, Groton, SD 57445",
    hours: "Mon–Fri 9:00am–12:00pm, 1:00pm–4:00pm",
    note: "Brown County community northeast",
    phone: "(605) 397-2222",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Webster Post Office",
    address: "221 W 1st Ave, Webster, SD 57274",
    hours: "Mon–Fri 8:30am–4:30pm",
    note: "Day County seat 50 miles northeast",
    phone: "(605) 345-3344",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Redfield Post Office",
    address: "521 Main St, Redfield, SD 57469",
    hours: "Mon–Fri 8:30am–4:30pm",
    note: "Spink County seat southwest of Aberdeen",
    phone: "(605) 472-2501",
    website: "https://tools.usps.com/find-location.htm",
  },
];

export default function AcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Aberdeen SD
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These local facilities are authorized to accept your passport application. Visit one to verify your identity and have your documents sealed. Fast Passport Center handles the agency submission after that.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {facilities.map((f, i) => (
            <div key={i} className="bg-white rounded-lg p-5 border border-gray-200 hover:border-[#F6C344] transition-all duration-200">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-lg"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm leading-snug">{f.name}</h3>
                  {f.note && <p className="text-[#F6C344] text-xs font-semibold mt-0.5">{f.note}</p>}
                </div>
              </div>
              <div className="space-y-1.5 text-sm text-gray-500">
                <div className="flex items-start gap-2">
                  <i className="ri-map-pin-line flex-shrink-0 mt-0.5 text-gray-400"></i>
                  <span>{f.address}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-time-line flex-shrink-0 text-gray-400"></i>
                  <span>{f.hours}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-phone-line flex-shrink-0 text-gray-400"></i>
                  <span>{f.phone}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-global-line flex-shrink-0 text-[#F6C344]"></i>
                  <a
                    href={f.website}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2 text-sm"
                  >
                    Visit website
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#1A365D] rounded-lg p-6 text-center">
          <p className="text-white/80 text-sm mb-3">
            Not sure which facility to visit? Call us and we will recommend the best option for your schedule and location.
          </p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}